import React from "react"

// =============================================================================
// Props
// =============================================================================

export type NavigationHeaderProps = {
  /** Logo, branding, trigger, or any content to display in the header */
  children?: React.ReactNode
}

// =============================================================================
// Styles
// =============================================================================

const headerStyles = "flex items-center justify-between mt-6 mb-2"

// =============================================================================
// Component
// =============================================================================

export function NavigationHeader({ children }: NavigationHeaderProps) {
  return (
    <div data-slot="navigation-header" className={headerStyles}>
      {children}
    </div>
  )
}

NavigationHeader.displayName = "Navigation.Header"
